export default "__VITE_ASSET__4079394d__"